import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FilterExpanderWithListOfCheckboxes } from '../../../../components/CustomExpander/componenets/filter-expander-with-list-of-checkboxes';
import { ProfessorsSalariesStatusesType } from '../../../../api/types/accountants/salaries-statuses/professors-salaries-statuses.type';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

export interface SalaryLecturerListProps {
  professorStatuses: ProfessorsSalariesStatusesType | undefined;
  onUserSelected: (user: UserSummaryType) => void;
}

export const SalaryLecturerList: React.FC<SalaryLecturerListProps> = observer(
  ({ professorStatuses, onUserSelected }) => {
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedOpenAccountUser, setSelectedOpenAccountUser] = useState<
      number | null
    >(null);
    const [selectedClosedAccountUsers, setSelectedClosedAccountUsers] =
      useState<number[]>([]);

    const handleOpenAccountUserToggle = (userId: number) => {
      if (selectedOpenAccountUser === userId) {
        setSelectedOpenAccountUser(null);
        setSelectedUserId(null);
      } else {
        setSelectedOpenAccountUser(userId);
        setSelectedUserId(userId);

        // Trigger HTTP request immediately
        const user = (professorStatuses?.pending ?? []).find(
          (u) => u.id === userId,
        );
        if (user) {
          onUserSelected(user);
        }
      }
    };

    const handleClosedAccountUserToggle = (userId: number) => {
      const isCurrentlySelected = selectedClosedAccountUsers.includes(userId);

      setSelectedClosedAccountUsers((prev) =>
        isCurrentlySelected
          ? prev.filter((id) => id !== userId)
          : [...prev, userId],
      );

      setSelectedUserId(userId);

      // Trigger HTTP request immediately
      if (!isCurrentlySelected) {
        const user = (professorStatuses?.pending ?? []).find(
          (u) => u.id === userId,
        );
        if (user) {
          onUserSelected(user);
        }
      }
    };

    const styles = {
      container: {
        width: '250px',
        maxWidth: '250px',
        minWidth: '250px',
        height: 'calc(100vh - 400px)', // Leave space for date filters above
        maxHeight: 'calc(100vh - 400px)',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column' as const,
      },
      header: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
      },
      content: {
        flex: 1,
        overflowY: 'auto' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        paddingRight: '4px',
      },
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>מרצים</div>
        <div style={styles.content}>
          <FilterExpanderWithListOfCheckboxes
            title="מרצים בחשבון פתוח"
            items={professorStatuses?.pending ?? []}
            selectedItems={
              selectedOpenAccountUser ? [selectedOpenAccountUser] : []
            }
            onItemToggle={handleOpenAccountUserToggle}
            getItemLabel={(user) => `${user.firstName} ${user.lastName}`}
            getItemKey={(user) => user.id}
            defaultExpanded={true}
            searchPlaceholder="חפש מרצה..."
          />

          {/*<FilterExpanderWithListOfCheckboxes
            title="מרצים בחשבון סגור"
            items={professorStatuses?.pending ?? []}
            selectedItems={selectedClosedAccountUsers}
            onItemToggle={handleClosedAccountUserToggle}
            getItemLabel={(user) => user.firstName}
            getItemKey={(user) => user.id}
            searchPlaceholder="חפש מרצה..."
          />*/}
        </div>
      </div>
    );
  },
);
